import { useReducer, useState } from "react"
import Axios from "./axios";




const useAuthApi = () => {
  const [user, setUser] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const getUserSession = async () => {
    try {
      const response = await Axios.get('/');
      const responseData = await response.data;
      if (responseData) {
        // setIsLoggedIn(true);
        setUser(responseData);
      }
    }catch (err) {
      console.log(err);
    }
  }

  const signIn = async (data) => {
    try {
      const response = await Axios.post('/signin', data);
      const responseData = await response.data;
      if (responseData) {
        // setIsLoggedIn(true);
        return responseData;
      }
    }catch (err) {
      console.log(err);
    }
  }

  const signOut = async () => {
    try {
      const response = await Axios.post('/signout');
      const responseData = await response.data;
      if (responseData) {
        setIsLoggedIn(false);
        return responseData;
      }
    }catch (err) {
      throw err;
    }
  }

  return {getUserSession, signIn, signOut, isLoggedIn, user};
}


export default useAuthApi;